import getApiClient, { getAnnonymousApiClient } from "./../../../shared/api";
import {
  showInfo,
  showError,
  clearNotifications
} from "../../../notifications/ducks/actions";
import auth from "../../../shared/auth";
import invitations from "../../../shared/invitations";
import { connection } from "../../../middleware/paymentSignalRMiddleware";
import { HubConnectionState } from "@microsoft/signalr";

export const PAYMENT_GET_CURRENCIES = "PAYMENT_GET_CURRENCIES";
export const CLEAR_PAYMENT = "CLEAR_PAYMENT";
export const CLEAR_PAYMENT_REDIRECT = "CLEAR_PAYMENT_REDIRECT;"
export const CREATE_PAYMENT_INTENT = "CREATE_PAYMENT_INTENT";
export const CREATE_PAYMENT_SESSION = "CREATE_PAYMENT_SESSION";
export const PAYMENT_ERROR = "PAYMENT_ERROR";
export const PAYMENT_PAYING = "PAYMENT_PAYING";
export const PAYMENT_PAID = "PAYMENT_PAID";
export const FETCH_PRICING_PLANS = "FETCH_PRICING_PLANS";
export const CHECK_DISCOUNT_CODE = "CHECK_DISCOUNT_CODE";
export const SET_PAYMENT_PENDING = "SET_PAYMENT_PENDING";
export const PAYMENT_GET_FULL_TOKEN = "PAYMENT_GET_FULL_TOKEN";
export const SET_PAYMENT_PAID_FOR_FREE_PRICING_PLAN = "SET_PAYMENT_PAID_FOR_FREE_PRICING_PLAN";

export function getCurrencies() {
  return (dispatch) => {
    dispatch({
      type: PAYMENT_GET_CURRENCIES,
      payload: getApiClient().get(`/lookup/Currencies`),
    });
  };
}

export function fetchPricingPlans() {
  return (dispatch) => {
    dispatch({
      type: FETCH_PRICING_PLANS,
      payload: getApiClient().get("/Lookup/PricingPlans")
    });
  };
}

export function checkDiscountCode(code: string, pricingPlan: number, currencyId: string) {
  return (dispatch) => {
    dispatch({
      type: CHECK_DISCOUNT_CODE,
      payload: getApiClient().get(`/lookup/CheckDiscount/${code}/${pricingPlan}/${currencyId}`)
    });
  };
}

export function getPaymentIntent(pricingPlan, currencyId, paymentMethodId, discountCode) {
  const userId = localStorage.getItem("userId");
  return (dispatch) => {
    dispatch({
      type: CREATE_PAYMENT_INTENT,
      payload: getApiClient().post(`/payment`,
        { pricingPlan, currencyId, paymentMethodId, discountCode },
        { headers: { "UserId": userId || "" } }
      )
    });
  };
}

export function getPaymentSession(pricingPlan, currencyId, discountCode) {
  return (dispatch) => {
    dispatch({
      type: CREATE_PAYMENT_SESSION,
      payload: getApiClient().post(`/payment/session`,
        { pricingPlan, currencyId, discountCode }
      )
    });
  };
}

export function setPaymentPending() {
  const user = auth.getUser();
  if (user.refreshToken) {
    // means we are logged in proplerly    
    return (dispatch) => {
      dispatch({
        type: PAYMENT_PAID,
      });
    };
  }

  if (connection.state === HubConnectionState.Disconnected) {
    connection.start().then(() => {
      connection.invoke('Subscribe', user.id).catch(e => {
        debugger;
        console.error(e);
      });
    }).catch(e => {
      debugger;
      console.error(e);
    })
  }

  return (dispatch) => {
    dispatch({
      type: SET_PAYMENT_PENDING,
      payload: getApiClient().post(`/payment/pending`,
        {}
      )
    });
  };
}

export function setPaymentPaidForFreePricingPlan() {
  return (dispatch) => {
    dispatch({
      type: SET_PAYMENT_PAID_FOR_FREE_PRICING_PLAN,
      payload: getApiClient().put(`/payment/SetPaymentPaidForFreePricingPlan`,
        {}
      )
    });
  };
}

export function getFullToken() {
  return (dispatch) => {
    dispatch({
      type: PAYMENT_GET_FULL_TOKEN,
      payload: getApiClient().get(`/account/fullToken`)
    });
  };
}

export function clearForm() {
  return (dispatch) => {
    dispatch({
      type: "PAYMENT_CLEAR_FORM",
    });
  };
}

export function payment(payment) {
  const userId = localStorage.getItem("userId");
  return (dispatch) => {
    dispatch({
      type: "PAYMENT",
      payload: getApiClient().post(`/payment`, payment),
      headers: { "UserId": userId },
      meta: { user: payment }
    }).then((response) => {
      invitations.removeReferralCode();
      dispatch(showInfo(`Successfully paid`));
    })
      .catch((response) => {
        dispatch(showError(`Error paying`));
      })
      .then((response) => {
        dispatch(clearNotifications());
      });
  };
}

export function clearRedirect() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_PAYMENT_REDIRECT,
    });
  };
}

export function clearRegistered() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_PAYMENT,
    });
  };
}

export function setError(error) {
  return (dispatch) => {
    dispatch({
      type: PAYMENT_ERROR,
      payload: error
    });
  };
}

export function setPaying(paying) {
  return (dispatch) => {
    dispatch({
      type: PAYMENT_PAYING,
      payload: paying
    });
  };
}

export function setPaid() {
  return (dispatch) => {
    dispatch({
      type: PAYMENT_PAID
    });
  };
}